// Change root App component here
export { default, ExtraHeader } from '../../browser/app/App'

